import * as React from "react";
import { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import classes from "./ViewDisputeAuthorization.module.css";

interface IParentProps {
  closeViewing: () => void;
}

interface IStateFromProps {
  disputeAuthorizationForm: string;
  t:any;
}

type Props = IParentProps & IStateFromProps;
class ViewDisputeAuthorization extends Component<Props> {
  state = {
    url: this.props.disputeAuthorizationForm,
  };
  render() {
    const { closeViewing,t } = { ...this.props };
    console.log("this.state.url", this.state.url);
    return (
      <Fragment>
        <div className="popupHeader">
          <h6>{t('balanceBills.viewBills')}</h6>
          <div className="closeBtn" onClick={closeViewing}>
            X
          </div>
        </div>

        <div className={classes.popupBody}>
          <div className={classes.imgBody}>
              {this.state.url && (
                //@ts-ignore
                <img src={URL.createObjectURL(this.state.url)} alt="..." />
              )}
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  disputeAuthorizationForm: state.disputeAuthorization.disputeAuthorizationForm,
});
// export default connect(mapStateToProps)(ViewDisputeAuthorization);
export default connect(mapStateToProps)(withTranslation()(ViewDisputeAuthorization));
